import { IconButton, Skeleton, Stack } from '@sixui/ui';

import type { ITableRowProps } from '~/components/molecules/Table/TableRow';
import { Table } from '~/components/molecules/Table';

export type IUserContentReviewListItemSkeletonProps = ITableRowProps;

export const UserContentReviewListItemSkeleton: React.FC<
  IUserContentReviewListItemSkeletonProps
> = (props) => {
  const { ...other } = props;

  return (
    <Table.Row {...other}>
      <Table.Body>
        <Skeleton length={{ min: 8, max: 56 }} />
      </Table.Body>
      <Table.Body>
        <Skeleton length={{ min: 24, max: 36 }} />
      </Table.Body>
      <Stack as={Table.Body} horizontal gap={3}>
        <Skeleton variant="circular">
          <IconButton icon={null} />
        </Skeleton>
        <Skeleton variant="circular">
          <IconButton icon={null} />
        </Skeleton>
      </Stack>
    </Table.Row>
  );
};
